
export class EmailOrder {
    customerName: string;
    deliveryAddress: any;
    orderDetails: any;
    
    emailId: string;
}
